import { COMPACT_GRID_WIDTH } from '@act/react-components/app/constants';
import { Box } from '@act/storybook';
import { useMobile } from '@act/utilities/MobileContext';
import { Portal } from '@mui/material';
import { useMinimizedCallDockReserveHeight } from './hooks/useMinimizedCallDockReserveHeight.hook';
import {
  getMinimizedCallDockZIndex,
  MINIMIZED_CALL_BANNER_DOCK_ELEMENT_ID,
} from '@act/toolkit/styles/callMinimize.constants';
import { ReactNode } from 'react';

export interface MinimizedCallBannerDockProps {
  /** When false, nothing is rendered. */
  visible: boolean;
  children: ReactNode;
}

/**
 * Fixed bottom dock for the minimized call banner, rendered outside the fullscreen dialog.
 * z-index stays below SpeedDial and MUI modals so plus-menu and leave confirmation stack above.
 *
 * @param props - Visibility flag and banner content.
 * @returns Portal-mounted banner dock or null.
 */
export const MinimizedCallBannerDock = ({
  visible,
  children,
}: MinimizedCallBannerDockProps) => {
  const { isMobile } = useMobile();

  useMinimizedCallDockReserveHeight(visible);

  if (!visible) {
    return null;
  }

  return (
    <Portal>
      <Box
        component="div"
        id={MINIMIZED_CALL_BANNER_DOCK_ELEMENT_ID}
        position="fixed"
        bottom={0}
        left={isMobile ? '0' : COMPACT_GRID_WIDTH}
        right={0}
        padding="0 16px"
        zIndex={getMinimizedCallDockZIndex()}
        pointerEvents="auto"
      >
        {children}
      </Box>
    </Portal>
  );
};
